import { getLocalTimezone } from '@utils/date-query';
import moment from 'moment';

export enum DateFormatTemplate {
    MonthFirstCalendarDate = 'MM/DD/YYYY'
}

export const formatAsLocalTimezone = (timestamp: string, formatTemplate: string = DateFormatTemplate.MonthFirstCalendarDate): string => {
    return moment.tz(timestamp, getLocalTimezone()).format(formatTemplate);
}

export const formatAsUTC = (
    timestamp: string,
    formatTemplate: string = DateFormatTemplate.MonthFirstCalendarDate
): string => {
    return moment.utc(timestamp).format(formatTemplate);
}

export const parseLocalDateStringAsISO = (input: string, format: string = DateFormatTemplate.MonthFirstCalendarDate): string => {
    if (!input || !format) {
        return '';
    }

    const parsedMoment = moment.tz(input, format, getLocalTimezone());
    if (!parsedMoment.isValid()) {
        return '';
    }

    return parsedMoment.toISOString();
}



// WEBPACK FOOTER //
// ./src/utils/date-format.ts